import React from "react";
import { Card, ListGroup } from "react-bootstrap";
import './Table.css';

const activities = [
  { id: 1, title: "Update of calendar events", highlight: "& Added new events in next week.", time: "4:45PM" },
  { id: 2, title: "New theme for ", highlight: "Spruko Website", description: " completed", time: "3 hrs" },
  { id: 3, title: "Created a ", highlight: "New Task", description: " today", time: "22 hrs" },
  { id: 4, title: "New member ", highlight: "@andreas", description: " added today to AI Summit.", time: "Today" },
  { id: 5, title: "32 New people joined summit.", time: "22 hrs" },
  { id: 6, title: "Neon Tarly added ", highlight: "Robert Bright", description: " to AI summit project.", time: "12 hrs" },
  { id: 7, title: "Replied to new support request", description: " ✔", time: "4 hrs" },
  { id: 8, title: "Completed documentation of ", highlight: "AI Summit.", time: "4 hrs" },
];

// Function to generate dynamic dot colors based on id
// const getDotColor = (id) => {
//   const colors = ["primary", "info", "success", "danger", "warning", "dark", "secondary", "light"];
//   return `bg-${colors[id % colors.length]}`;
// };



const getTextColor = (id) => {
  const colors = ["text-primary", "text-info", "text-success", "text-danger", "text-warning", "text-dark", "text-secondary", "text-muted"];
  return colors[id % colors.length];
};

const ActivityCard = () => {
  return (
    <Card className="shadow-sm border-0" style={{ height: "465px", overflow: "hidden" }}>
      {/* Card Header */}
      <Card.Header className="d-flex justify-content-between align-items-center bg-white border-bottom">
        <h5 className="mb-0 fw-bold">Recent Activity</h5>
        <button className="btn btn-sm btn-link text-decoration-none text-primary">View All ▼</button>
      </Card.Header>

      {/* Scrollable Content */}
      <div style={{
        height: "calc(100% - 60px)", // Adjust height dynamically (450px - header height)
        overflowY: "auto",
        paddingRight: "10px",
      }}
        className="custom-scrollbar">
        <ListGroup variant="flush">
          {activities.map((activity) => (
            <ListGroup.Item key={activity.id} className="border-0 d-flex align-items-start">
              <span className="me-3 mt-1 rounded-circle d-inline-block bg-primary" style={{ width: "10px", height: "10px" }}></span>
              <div className="flex-grow-1">
                <p className="mb-1 fw-semibold text-dark">
                  {activity.title}
                  {activity.highlight && <span className={`fw-bold ${getTextColor(activity.id)}`}> {activity.highlight}</span>}
                  {activity.description && <span className="text-muted"> {activity.description}</span>}
                </p>
                <small className="text-muted">{activity.time}</small>
              </div>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </div>
    </Card>
  );
};

export default ActivityCard;
